const actionTypes = {
    SET_STATAIC_PERMISSIONS: 'SET_STATAIC_PERMISSIONS',
    SET_SITE_LANGUAGE: 'SET_SITE_LANGUAGE',
    SET_CONFIGURATION: 'SET_CONFIGURATION',
};

export default actionTypes;
